import { useTranslation } from "react-i18next";
import { Button } from "~/components/button";
import { Text } from "~/components/text";
import { copyToClipboard } from "~/utils/helpers";
import { toast } from "~/utils/toast";
import { withParagraphKeys } from "./utils";

interface SummarySectionProps {
  contentLanguage: string | undefined;
  paragraphHistory: string[];
}

export const SummarySection = ({
  contentLanguage,
  paragraphHistory,
}: SummarySectionProps) => {
  const { t } = useTranslation(["productDetails", "general"]);
  const paragraphs = withParagraphKeys(paragraphHistory);

  const copySummary = () =>
    copyToClipboard({
      arrayToCopy: paragraphHistory,
      delimiter: "\n\n",
      onDone: () => toast.success(t("productDetails:summary.copy.success")),
    });

  return (
    <section aria-labelledby="summary-section-title" className="space-y-6">
      <div className="flex items-center justify-between gap-4">
        <Text
          as="h2"
          id="summary-section-title"
          variant="heading"
          className="text-balance"
        >
          {t("productDetails:summary.sections.summary")}
        </Text>
        <Button
          label={t("general:buttons.copy")}
          variant="tertiary"
          size="small"
          analyticsId="button_copy_summary"
          onClick={copySummary}
          className="min-h-10 shrink-0"
        />
      </div>
      <div className="space-y-5 rounded-xl border border-secondary-200 bg-secondary-25 p-6">
        {paragraphs.map((paragraph) => (
          <Text
            key={paragraph.key}
            variant="body"
            className="text-pretty"
            lang={contentLanguage}
          >
            {paragraph.text}
          </Text>
        ))}
      </div>
    </section>
  );
};
